import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import config from '../../config/config';
import CustomInputLabel from './CustomInputLabel';

const HelperText = props => {
  const { children, className } = props;
  return (
    <Typography className={`${className || ''}`}
      sx={{ bgcolor: 'none', padding: '3px 7.5px' }}
      variant='helperText'
    >
      {children}
    </Typography>
  );
};

const CustomInput = props => (
  <FormControl
    variant='standard'
    style={{ maxWidth: props.maxWidth || null }}
    fullWidth={props?.fullWidth || false}
    className={`CustomInput ${props.className || ''}`}
  >
    {
      props.label
        ? <CustomInputLabel required={props?.required || false}>
          {props.label}
        </CustomInputLabel>
        : <></>
    }
    {
      props.buttonRight
        ?
        <Stack direction='row' spacing={2}>
          <Box className='w-100'>
            {props.children}
            {props.helperText && <HelperText className={props.helperTextClass}>{props.helperText}</HelperText>}
          </Box>
          <Box>
            {props.buttonRight}
          </Box>
        </Stack>
        :
        <>
          {props.children}
          {props.helperText && <HelperText className={props.helperTextClass}>{props.helperText}</HelperText>}
        </>
    }

  </FormControl>
);

export default CustomInput;
